import initPlayer from '../global/init-player';

const videoFull = {
	videoSection: document.querySelectorAll('.js-video-full-section'),
	videoActiveClass: 'video-full--active',
	videoOptions: {
		autoplay: true,
		muted: true,
		vimeo: {
			background: true,
			autopause: false,
		},
	},

	init: function() {
		this.videoPlayEventHandler();
		this.animateVideoOnScroll();
	},

	animateVideoOnScroll: function() {
		const videoStatus = 'video--playing';
		const largeTablet =
			window.innerWidth >= 1024 && window.innerWidth < 1200;

		window.addEventListener('scroll', () => {
			const screenHeight = largeTablet
				? window.innerHeight * 0.9
				: window.innerHeight;
			const offsetScreen = window.scrollY + screenHeight;

			document
				.querySelectorAll('.js-video-full-content')
				.forEach((holder) => {
					const videoComponent = holder.closest('.video-full');
					const openedVideo =
						videoComponent.classList.contains(videoStatus);
					const offItem = holder.offsetTop;
					let itemRadius = 30;
					let vp = 0.7;

					if (window.innerWidth >= 1024 && window.innerWidth < 1200) {
						vp = 0.75;
					} else if (
						window.innerWidth >= 768 &&
						window.innerWidth < 1023
					) {
						vp = 0.85;
					} else if (window.innerWidth < 767) {
						vp = 0.7;
						itemRadius = 15;
					}

					if (isInViewport(holder, vp) && window.scrollY > 0) {
						const itemPercent =
							(offsetScreen - offItem) / holder.clientHeight;
						let percent = itemPercent * 100;
						let borderRadius =
							holder.clientHeight -
							holder.clientHeight * (itemPercent * 1.1);

						if (window.innerWidth < 767) {
							percent = percent / 2;
						}

						if (
							window.innerWidth >= 768 &&
							window.innerWidth < 1200
						) {
							borderRadius = 150 - 75 * itemPercent;
						} else if (window.innerWidth < 767) {
							borderRadius = 100 - (50 * itemPercent) / 2;
						}

						const btnPlay = holder.querySelector('.js-btn-play');
						const videoInfo =
							holder.querySelector('.video-full__info');

						if (btnPlay && videoInfo) {
							if (percent > 90) {
								btnPlay.classList.add(
									'video-full__btn--visible'
								);
								videoInfo.classList.add(
									'video-full__info--active'
								);
							} else {
								btnPlay.classList.remove(
									'video-full__btn--visible'
								);
								videoInfo.classList.remove(
									'video-full__info--active'
								);
							}
						}

						if (percent > 99) {
							percent = 100;
							holder.classList.add('completed');
						} else {
							holder.classList.remove('completed');
						}

						if (!openedVideo) {
							holder.style.width = percent + '%';

							if (window.innerWidth < 767) {
								holder.style.width = percent + 40 + '%';
							}

							if (borderRadius <= itemRadius) {
								holder.querySelector(
									'.video__crop'
								).style.borderRadius =
									convertPxToVW(itemRadius);
							} else {
								holder.querySelector(
									'.video__crop'
								).style.borderRadius =
									convertPxToVW(borderRadius);
							}
						}
					} else {
						holder.removeAttribute('style');
						holder
							.querySelector('.video__crop')
							.removeAttribute('style');

						if (videoComponent.classList.contains(videoStatus)) {
							videoComponent.classList.remove(videoStatus);
							videoComponent
								.querySelector('.js-video-close')
								.click();
						}
					}
				});
		});

		function isInViewport(element, viewportPercentage) {
			const rect = element.getBoundingClientRect();
			const windowHeight =
				window.innerHeight || document.documentElement.clientHeight;
			const topInView = rect.top < windowHeight * viewportPercentage;
			const bottomInView = rect.bottom > 0;

			return topInView && bottomInView;
		}

		function convertPxToVW(px) {
			const viewportWidth =
				window.innerWidth || document.documentElement.clientWidth;
			return (px / viewportWidth) * 100 + 'vw';
		}
	},

	videoPlayEventHandler: function() {
		this.videoSection.forEach((section) => {
			const video = section.querySelector('.js-video-full-video');
			const button = section.querySelector('.js-btn-play');
			this.playVideo(button, video, section);
		});
	},

	playVideo: function(btn, video, section) {
		if (btn) {
			btn.addEventListener('click', () => {
				initPlayer(video, this.videoOptions);
				section.classList.add(this.videoActiveClass);
			});
		}
	},
};

export default videoFull;
